/**
 * Use this util within a MutationObserver callback.
 * This waits for all `addedNodes[].componentOnReady` to be called.
 * @returns {Promise} Promise when the elements are ready
 */
function waitForAddedNodesToBeReady(mutationList) {
  const addedNodes = mutationList.reduce((nodes, record) => {
    for (const node of record.addedNodes) {
      if (typeof node.componentOnReady === 'function') {
        nodes.push(node);
      }
    }
    return nodes;
  }, []);
  return Promise.all(addedNodes.map(async (node) => {
    await node.componentOnReady();
    return Promise.resolve();
  }));
}

export { waitForAddedNodesToBeReady as w };
